module.exports = __webpack_public_path__ + "img/Wolfsburg.ed6918fd.png";